import { makeStyles } from '@material-ui/core'
import React, { useState } from 'react'
import { tokens } from './tokens'
import { Container } from './Container'
import { SectionTitle } from './SectionTitle'

const FAQ_ITEMS = [
    { q: 'How long does custom fixture development take?', a: 'Depending on the difficulty of the design, it usually takes us 10 to 15 business days from design approval to send the product.' },
    { q: 'Can you support on-site installation and commissioning?', a: 'On request, we send our own technicians to your site for the installation, commissioning and training of the system.' },
    { q: 'Do you offer revision or upgrade services for existing fixtures?', a: 'We also carry out upgrading and alterations to test fixtures so that they are suitable for both new designs and better testing methods.' },
    { q: 'What information do I need to provide to get a custom test fixture designed?', a: 'Generally, we start fixture design by obtaining the product schematic, 3D model or sample, list of test points/pins, test specifications and information on connected instruments.' },
    { q: 'Do your test fixtures support both manual and automated testing?', a: 'There are both manual and automated solutions available from us. Our experts will suggest the right method, based on the size of your production and how complicated your tests are.' },
    { q: 'Can your fixtures integrate with third-party test instruments?', a: 'Yes. Our fixtures link to NI, Keysight, GW Instek, and bespoke test platforms via USB, RS232, LAN, or GPIB.' },
    { q: 'Do you offer HIPOT or functional testing fixtures?', a: 'We make devices that assist with high-voltage testing, insulation resistance, leakage current and all appropriate operational testing for safety compliance.' },
    { q: 'Is there training given once the fixture arrives?', a: 'Absolutely, we offer instructions and detailed training for working, handling and maintaining the supplied fixture.' },
    { q: 'Do you provide mechanical-only test jigs (without electronics)?', a: 'We have the option to send just the mechanical-built part (the bed-of-nails or the enclosures) if you want to setup your own electronics and software.' },
]

const useStyles = makeStyles(() => ({
    section: { padding: '90px 0' },
    list: {
        maxWidth: 900,
        margin: '0 auto',
        borderTop: `1px solid ${tokens.colorBorder}`,
        
    },
    item: { borderBottom: `1px solid ${tokens.colorBorder}` },
    question: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        background: 'none',
        border: 'none',
        padding: '20px 6px',
        textAlign: 'left',
        fontFamily: tokens.fontHeading,
        fontSize: '1rem',
        fontWeight: 600,
        color: tokens.colorBlack,
        cursor: 'pointer',
        transition: `color ${tokens.transition}, background ${tokens.transition}, border-radius ${tokens.transition}`,
        fontFamily: tokens.fontBody,
    },
    questionOpen: {
        background: tokens.colorPrimary,
        color: '#fff',
        borderRadius: tokens.radiusSm,
        padding: '18px 20px',
    },
    toggle: {
        flex: '0 0 auto',
        width: 26, height: 26,
        borderRadius: '50%',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        border: `1px solid ${tokens.colorBorder}`,
        fontSize: '.95rem',
    },
    toggleOpen: { borderColor: 'rgba(255,255,255,0.5)' ,},
    answer: {
        maxHeight: 0,
        overflow: 'hidden',
        transition: `max-height .35s ease, padding ${tokens.transition}`,
        padding: '0 20px',
    },
    answerOpen: { maxHeight: 200, padding: '16px 20px 22px' },
    answerText: { color: tokens.colorTextLight, fontSize: '16px', margin: 0 ,fontFamily: tokens.fontBody,},
}))

export function Faqs() {
    const classes = useStyles()
    const [openIndex, setOpenIndex] = useState(0)

    return (
        <section className={classes.section} id="faqs">
            <Container>
                <SectionTitle>FAQs</SectionTitle>
                <div className={classes.list}>
                    {FAQ_ITEMS.map((item, i) => {
                        const isOpen = openIndex === i
                        return (
                            <div className={classes.item} key={item.q}>
                                <button
                                    className={`${classes.question} ${isOpen ? classes.questionOpen : ''}`}
                                    aria-expanded={isOpen}
                                    onClick={() => setOpenIndex(isOpen ? -1 : i)}
                                >
                                    <span>{item.q}</span>
                                    <span className={`${classes.toggle} ${isOpen ? classes.toggleOpen : ''}`} aria-hidden="true">
                                        {isOpen ? '\u2212' : '+'}
                                    </span>
                                </button>
                                <div className={`${classes.answer} ${isOpen ? classes.answerOpen : ''}`}>
                                    <p className={classes.answerText}>{item.a}</p>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </Container>
        </section>
    )
}
